// components/CopyResults.jsx

import React from 'react';

const CopyResults = ({ results, onClose, onCopyMore }) => {
  if (!results) {
    return (
      <div style={{ textAlign: 'center', padding: '32px 0' }}>
        <div style={{
          width: '32px',
          height: '32px',
          border: '4px solid #3b82f6',
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }}></div>
        <p style={{ color: '#6b7280' }}>Processing copy operation...</p>
      </div>
    );
  }

  const { status, summary, results_by_table, failed_tables } = results;
  const isSuccess = status === 'Success';
  const isPartialSuccess = status === 'Partial Success';
  const isFailed = status === 'Failed';

  const getStatusColor = () => {
    if (isSuccess) return '#059669';
    if (isPartialSuccess) return '#d97706';
    return '#dc2626';
  };

  const getStatusIcon = () => {
    if (isSuccess) {
      return (
        <svg width="48" height="48" fill="none" stroke="#059669" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      );
    }
    if (isPartialSuccess) {
      return (
        <svg width="48" height="48" fill="none" stroke="#d97706" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    }
    return (
      <svg width="48" height="48" fill="none" stroke="#dc2626" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    );
  };

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
          {getStatusIcon()}
        </div>
        <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: getStatusColor(), marginBottom: '8px' }}>
          Copy {status}
        </h3>
        <p style={{ color: '#6b7280' }}>
          {results.status_description}
        </p>
      </div>

      {/* Summary - Only show if summary exists */}
      {summary && (
        <div style={{
          backgroundColor: '#f9fafb',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '24px'
        }}>
          <h4 style={{ fontWeight: 'bold', color: '#111827', marginBottom: '12px' }}>Summary</h4>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '16px',
            fontSize: '14px'
          }}>
            {summary.copy_from_project_id && (
              <div>
                <span style={{ color: '#6b7280' }}>From Project:</span>
                <div style={{ fontWeight: 'bold' }}>{summary.copy_from_project_id}</div>
              </div>
            )}
            {summary.copy_to_project_id && (
              <div>
                <span style={{ color: '#6b7280' }}>To Project:</span>
                <div style={{ fontWeight: 'bold' }}>{summary.copy_to_project_id}</div>
              </div>
            )}
            {summary.tables_processed !== undefined && (
              <div>
                <span style={{ color: '#6b7280' }}>Tables Processed:</span>
                <div style={{ fontWeight: 'bold' }}>{summary.tables_processed}</div>
              </div>
            )}
            {summary.tables_succeeded !== undefined && (
              <div>
                <span style={{ color: '#6b7280' }}>Tables Succeeded:</span>
                <div style={{ fontWeight: 'bold', color: '#059669' }}>{summary.tables_succeeded}</div>
              </div>
            )}
            {summary.tables_failed !== undefined && (
              <div>
                <span style={{ color: '#6b7280' }}>Tables Failed:</span>
                <div style={{ fontWeight: 'bold', color: '#dc2626' }}>{summary.tables_failed}</div>
              </div>
            )}
            {results.total_records_copied !== undefined && (
              <div>
                <span style={{ color: '#6b7280' }}>Total Records Copied:</span>
                <div style={{ fontWeight: 'bold' }}>{results.total_records_copied}</div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Detailed Results */}
      {results_by_table && Object.keys(results_by_table).length > 0 && (
        <div style={{ marginBottom: '24px' }}>
          <h4 style={{ fontWeight: 'bold', color: '#111827', marginBottom: '12px' }}>Detailed Results</h4>
          <div style={{
            maxHeight: '256px',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
            {Object.entries(results_by_table).map(([tableName, result]) => (
              <div
                key={tableName}
                style={{
                  padding: '12px',
                  borderRadius: '8px',
                  border: `1px solid ${result.success ? '#bbf7d0' : '#fecaca'}`,
                  backgroundColor: result.success ? '#f0fdf4' : '#fef2f2'
                }}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '4px'
                }}>
                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{tableName}</span>
                  <span style={{
                    fontSize: '12px',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    backgroundColor: result.success ? '#dcfce7' : '#fee2e2',
                    color: result.success ? '#166534' : '#991b1b'
                  }}>
                    {result.success ? 'Success' : 'Failed'}
                  </span>
                </div>
                <div style={{ fontSize: '12px', color: '#6b7280' }}>
                  Records copied: {result.records_copied || 0}
                </div>
                {result.error_message && (
                  <div style={{
                    fontSize: '12px',
                    color: '#dc2626',
                    marginTop: '4px',
                    fontStyle: 'italic'
                  }}>
                    Error: {result.error_message}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Action Buttons - Removed from here, moved to footer */}
    </div>
  );
};

export default CopyResults;